import React, { useState } from 'react';
import { RiUserSettingsLine } from 'react-icons/ri';
import { FaChalkboardTeacher } from 'react-icons/fa';
import { GoPeople } from 'react-icons/go';
import { PiStudentBold } from 'react-icons/pi';
import logo from "../../images/gurusidebar.png";
import { useNavigate } from 'react-router-dom';

export default function LoginScreens() {
  const [loading, setLoading] = useState({});
  const navigate = useNavigate();

  const handleButtonClick = (url, index) => {
    setLoading(prev => ({ ...prev, [index]: true }));
    setTimeout(() => {
      navigate(url);
    }, 1000);
  };

  const users = [
    { url: '/login', icon: <RiUserSettingsLine size={50} color='white' />, name: "Admin" },
    { url: '/teacher/login', icon: <FaChalkboardTeacher size={50} color='white' />, name: "Teacher" },
    { url: '/staff/login', icon: <GoPeople size={50} color='white' />, name: "Staff" },
    { url: '/student/login', icon: <PiStudentBold size={50} color='white' />, name: "Student" },
  ];

  return (
    <div className="container d-flex flex-column justify-content-center align-items-center">
      <img className="logo mb-2" src={logo} alt="Logo" width="150" />
      <div className="row row-cols-1 row-cols-md-2 g-4">
        {users.map((ele, i) => (
          <div className="col" key={i}>
            <div className="card shadow-lg rounded-lg overflow-hidden text-center position-relative">
              <div className="card-body bg-image" style={{ backgroundImage: `url(/images/big/img5.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundColor:'var(--primary)' }}>
                {ele.icon}
                <h3 className="mt-3 mb-0 text-white">{ele.name}</h3>
              </div>
              <div className="card-footer mt-0">
                <button
                  className="btn btn-primary btn-lg btn-block"
                  onClick={() => handleButtonClick(ele.url, i)}
                  disabled={loading[i]}
                >
                  {loading[i] ? (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  ) : (
                    'Login'
                  )}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}